import { createSelector } from 'reselect';

export const isLoading = ({ loading }) => loading;

export const factory = getScope => ({
  isLoading: createSelector(
    getScope,
    isLoading,
  ),
});

export default factory;
